import { liveFeed } from "@/mocks/liveFeed";

const typeDot: Record<string, string> = {
  娱乐: "bg-primary-500",
  影视: "bg-secondary-500",
  科技: "bg-accent-500",
  体育: "bg-foreground-700",
  社会: "bg-background-500",
};

export default function LiveTicker() {
  const tickerItems = [...liveFeed, ...liveFeed];

  return (
    <section aria-label="最新快讯滚动条" className="w-full bg-foreground-900 text-background-100 overflow-hidden">
      <div className="flex items-center">
        <div className="shrink-0 flex items-center gap-2 px-4 md:px-6 py-3 bg-primary-500 text-background-50">
          <i className="ri-radar-line text-lg w-5 h-5 flex items-center justify-center animate-pulse-dot" aria-hidden="true"></i>
          <span className="text-sm font-medium whitespace-nowrap">最新滚动</span>
        </div>

        <div className="relative flex-1 overflow-hidden py-3">
          <div className="ticker-track">
            {tickerItems.map((item, index) => (
              <a
                key={`${item.id}-${index}`}
                href="#live"
                className="inline-flex items-center gap-2.5 px-5 text-sm text-background-200 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap"
              >
                <span className={`w-1.5 h-1.5 rounded-full ${typeDot[item.type] ?? "bg-background-400"}`} aria-hidden="true"></span>
                <span className="tabular-nums text-background-400">{item.time}</span>
                <span>{item.title}</span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}